import { createStore, applyMiddleware } from 'redux'
import reducer from 'reducers'
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension';

const loggerMiddleware = createLogger();
const composeEnhancers = composeWithDevTools({
  trace: true,
 });

const initStore = (reducer) => createStore(
    reducer,
    composeEnhancers(
      applyMiddleware(
        thunkMiddleware,
        loggerMiddleware
      )
    )
  );

const store = initStore(reducer);


export default store;